import service from '@/services/superaccess'

const site = {
  state: {
    modal: false
  },
  mutations: {
    updateStatusSiteModal (state, status) {
      state.modal = status
    }
  },
  getters: {
    getStatusSiteModal (context) {
      return context.modal
    }
  },
  actions: {
    setStatusSiteModal (context, payload) {
      context.commit('updateStatusSiteModal', payload)
    },
    createSite (context, payload) {
      return service.post('/api/sites/create', context, { site: payload })
    },
    modifySite (context, payload) {
      return service.patch('/api/sites/modify', context, { site: payload })
    },
    changeSiteState (context, payload) {
      return service.patch('/api/sites/change', context, payload)
    }
  }
}

export default site



// WEBPACK FOOTER //
// app/javascript/src/store/site.js